import React from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import style from './Input.module.scss';


class Input extends React.Component {
  render() {
    const {type, id, placeholder, value, label, onChange} = this.props;

    return (
      <div className={`${style.inputContainer}`}>
        <input type={type} id={id} placeholder={placeholder} value={value} className={`form-control ${value ? style.active: ''}`} onChange={(e) => {
          onChange(e.target.value);
        }} />
        <label htmlFor={id} className={`${value ? style.active: ''}`}>{label}</label>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(undefined, mapDispatchToProps)(withRouter(Input));
